export var CHOOSEN_OPTIONS = {
  VIDEO_START: 'video_start',
  VIDEO_PLAY: 'video_play',
  VIDEO_PAUSE: 'video_pause',
  CROSS: 'cross',
  CTA_CLICK: 'cta_click',
  BACK: 'back'
};
export var FLOW_TYPES = {
  END_REACHED: 'end_reached',
  END_NOT_REACHED: 'end_not_reached'
};
export var INTENTS = {
  PLAY: 'play',
  PAUSE: 'pause'
};
export var SELECT_FROM = {
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait'
};